import { render, staticRenderFns } from "./OrderClosedModal.vue?vue&type=template&id=d331e7c4&scoped=true"
import script from "./OrderClosedModal.vue?vue&type=script&lang=js"
export * from "./OrderClosedModal.vue?vue&type=script&lang=js"
import style0 from "./OrderClosedModal.vue?vue&type=style&index=0&id=d331e7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d331e7c4",
  null
  
)

export default component.exports